export const blurActiveElement = () => {
    const activeElement = document?.activeElement;
    if (!(activeElement instanceof HTMLElement)) return;

    activeElement.blur();
};
